(() => {
  'use strict';

  const getRoot = () => document.querySelector('[data-bazaar-core-rooms]');
  const getRoom = name => getRoot()?.querySelector(`[data-bazaar-room-dialog="${name}"]`) || null;

  const closeRoom = room => {
    if (!room) return;
    try { if (typeof room.close === 'function') room.close(); else room.removeAttribute('open'); }
    catch (_) { room.removeAttribute('open'); }
    document.documentElement.classList.remove('bazaar-room-is-open');
  };

  const openRoom = name => {
    const room = getRoom(name);
    if (!room) {
      console.error('[Hidden Bazaar] Room not found:', name);
      return false;
    }
    // Close another room first if needed.
    getRoot()?.querySelectorAll('[data-bazaar-room-dialog][open]').forEach(open => {
      if (open !== room) closeRoom(open);
    });
    try {
      if (typeof room.showModal === 'function') {
        if (!room.open) room.showModal();
      } else {
        room.setAttribute('open', '');
      }
    } catch (_) {
      room.setAttribute('open', '');
    }
    document.documentElement.classList.add('bazaar-room-is-open');
    window.setTimeout(() => room.querySelector('[data-bazaar-room-close],button,input,select,textarea,a[href]')?.focus({preventScroll:true}), 0);
    return true;
  };

  window.HiddenBazaarRooms = { open: openRoom, close: closeRoom };

  // Capture-phase interception ensures no other theme script can convert a room action into navigation.
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-bazaar-room-open]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openRoom(trigger.dataset.bazaarRoomOpen);
  }, true);

  document.addEventListener('keydown', event => {
    const trigger = event.target.closest?.('[data-bazaar-room-open]');
    if (!trigger) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    event.stopPropagation();
    openRoom(trigger.dataset.bazaarRoomOpen);
  }, true);

  document.addEventListener('click', event => {
    const close = event.target.closest('[data-bazaar-room-close]');
    if (close) {
      event.preventDefault();
      closeRoom(close.closest('[data-bazaar-room-dialog]'));
      return;
    }
    const room = event.target.closest('[data-bazaar-room-dialog]');
    if (room && event.target === room) closeRoom(room);
  });

  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-bazaar-room-dialog]')) {
      document.documentElement.classList.remove('bazaar-room-is-open');
    }
  }, true);
})();
